import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Calendar, Clock, Users, MessageSquare } from 'lucide-react';
export function ReservationForm() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    guests: '2',
    notes: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle submission logic
    console.log('Reservation submitted:', formState);
    alert('Reservation request received!');
  };
  const inputClasses = 'w-full bg-navy-900 border-2 border-navy-700 text-white px-4 py-3 focus:border-ocean-500 focus:outline-none focus:ring-1 focus:ring-ocean-500 transition-all duration-300 placeholder-gray-500';
  const labelClasses = 'block text-gold-500 font-heading font-bold text-sm uppercase tracking-wide mb-2';
  return <section id="reservations" className="py-24 bg-navy-900 relative" data-id="element-135">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="bg-navy-800 p-8 md:p-12 border border-navy-700 shadow-2xl relative overflow-hidden" data-id="element-137">
          {/* Decorative accent */}
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold-500 via-ocean-500 to-gold-500" data-id="element-138" />

          <div className="text-center mb-10" data-id="element-139">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-2" data-id="element-140">
              Secure Your Table
            </h2>
            <p className="text-gray-400" data-id="element-141">
              Join us for an unforgettable evening.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-142">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-143">
              <div data-id="element-144">
                <label htmlFor="name" className={labelClasses} data-id="element-145">
                  Full Name
                </label>
                <input type="text" id="name" name="name" required className={inputClasses} placeholder="John Doe" value={formState.name} onChange={handleChange} data-id="element-146" />
              </div>
              <div data-id="element-147">
                <label htmlFor="email" className={labelClasses} data-id="element-148">
                  Email Address
                </label>
                <input type="email" id="email" name="email" required className={inputClasses} placeholder="john@example.com" value={formState.email} onChange={handleChange} data-id="element-149" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-150">
              <div data-id="element-151">
                <label htmlFor="date" className={labelClasses} data-id="element-152">
                  <span className="flex items-center gap-2" data-id="element-153">
                    <Calendar className="w-4 h-4" data-id="element-154" /> Date
                  </span>
                </label>
                <input type="date" id="date" name="date" required className={inputClasses} value={formState.date} onChange={handleChange} data-id="element-155" />
              </div>
              <div data-id="element-156">
                <label htmlFor="time" className={labelClasses} data-id="element-157">
                  <span className="flex items-center gap-2" data-id="element-158">
                    <Clock className="w-4 h-4" data-id="element-159" /> Time
                  </span>
                </label>
                <select id="time" name="time" required className={inputClasses} value={formState.time} onChange={handleChange} data-id="element-160">
                  <option value="" data-id="element-161">Select Time</option>
                  <option value="17:00" data-id="element-162">5:00 PM</option>
                  <option value="17:30" data-id="element-163">5:30 PM</option>
                  <option value="18:00" data-id="element-164">6:00 PM</option>
                  <option value="18:30" data-id="element-165">6:30 PM</option>
                  <option value="19:00" data-id="element-166">7:00 PM</option>
                  <option value="19:30" data-id="element-167">7:30 PM</option>
                  <option value="20:00" data-id="element-168">8:00 PM</option>
                  <option value="20:30" data-id="element-169">8:30 PM</option>
                </select>
              </div>
              <div data-id="element-170">
                <label htmlFor="guests" className={labelClasses} data-id="element-171">
                  <span className="flex items-center gap-2" data-id="element-172">
                    <Users className="w-4 h-4" data-id="element-173" /> Guests
                  </span>
                </label>
                <select id="guests" name="guests" className={inputClasses} value={formState.guests} onChange={handleChange} data-id="element-174">
                  {[1, 2, 3, 4, 5, 6, 7, 8].map(num => <option key={num} value={num} data-id="element-175">
                      {num} {num === 1 ? 'Guest' : 'Guests'}
                    </option>)}
                  <option value="9+" data-id="element-176">9+ (Call us)</option>
                </select>
              </div>
            </div>

            <div data-id="element-177">
              <label htmlFor="notes" className={labelClasses} data-id="element-178">
                <span className="flex items-center gap-2" data-id="element-179">
                  <MessageSquare className="w-4 h-4" data-id="element-180" /> Special Requests
                </span>
              </label>
              <textarea id="notes" name="notes" rows={3} className={inputClasses} placeholder="Allergies, special occasions, seating preference..." value={formState.notes} onChange={handleChange} data-id="element-181" />
            </div>

            <div className="pt-4" data-id="element-182">
              <Button type="submit" variant="primary" size="lg" className="w-full" data-id="element-183">
                Confirm Reservation
              </Button>
            </div>
          </form>
        </div>
      </div>
    </section>;
}